import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  public host = 'https://pwa.the-erm.com';
  constructor(private router:Router, private http:HttpClient) {
  }

  get loggedIn():boolean {
    if (typeof localStorage.token != 'undefined' && localStorage.token) {
      return true;
    }
    return false;
  }

  login(username, password) {

  }
  logout() {
    if (confirm("Are you sure you want to logout?  If you're offline you can't log back in.")) {
      this.http.post(this.host+"/api/logout.php?token="+localStorage.token, []).subscribe((res:any[]) => {

      });
      localStorage.token = null;
      delete localStorage.token;
      this.router.navigate(['/login']);
    }
  }
}
